import { render, staticRenderFns } from "./RepresentativeProducts.vue?vue&type=template&id=2ab9938f&scoped=true"
import script from "./RepresentativeProducts.vue?vue&type=script&lang=js"
export * from "./RepresentativeProducts.vue?vue&type=script&lang=js"
import style0 from "./RepresentativeProducts.vue?vue&type=style&index=0&id=2ab9938f&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab9938f",
  null
  
)

export default component.exports